export const serverUrl = "https://flightdrop-backend-jack.herokuapp.com/";

export const botMessages = [
  [
    {
      type: "bot",
      message: "Welcome to Ecosystem.",
    },
    {
      type: "bot",
      message:
        "I'm your chatbot helper who will help you create your bespoke portals and content.",
    },
    {
      type: "bot",
      message:
        "Once you've added your information and branding I'll be customized to help your brand.",
    },
    {
      type: "bot",
      message:
        "It takes a few minutes to set up and unlock endless engagement opportunities.",
    },
    {
      type: "bot",
      message: "May I take your first name please?",
    },
  ],
  [
    {
      type: "bot",
      message: "Ok, so let's register your brand name?",
    },
  ],
  [
    {
      type: "bot",
      message:
        "Alright, so next I need a circular icon to use with your chatbots.",
    },
    {
      type: "bot",
      message:
        "This is going to make all of your chatbots look very cool. A png with no background would be best please?",
    },
  ],
  [
    {
      type: "bot",
      message:
        "Almost complete, please tell me your website so we can link that up.",
    },
  ],
  [
    {
      type: "bot",
      message: "Ok that's everything complete.",
    },
    {
      type: "bot",
      message:
        "Enjoy exploring your brand portal and let me know if you need help.",
    },
  ],
];
export const userMessages = [
  {
    type: "user",
    inputType: "input",
    key: "firstname",
    placeholder: "Enter your First Name only.",
    isNext: true,
  },
  {
    type: "user",
    inputType: "input",
    key: "email",
    placeholder: "Enter your Email address.",
    isNext: true,
  },

  {
    type: "user",
    inputType: "input",
    key: "brand",
    placeholder: "Enter your Brand name.",
    isNext: true,
  },
  {
    type: "user",
    inputType: "upload",
    placeholder: "Logo Upload PNG",
    key: "logo",
  },
  {
    type: "user",
    inputType: "upload",
    placeholder: "Icon Upload PNG",
    key: "icon",
  },

  {
    type: "user",
    inputType: "input",
    key: "website",
    placeholder: "https://xxx.xxx",
    isNext: true,
  },
  {
    type: "user",
    inputType: "static",
    key: "finish",
    message: "Let's Get Started",
    style: { backgroundColor: "#D5FEC6", color: "#152439" },
    finish: true,
  },
];



// WEBPACK FOOTER //
// ./src/Constants/messages.js